import React, { useEffect, useState } from 'react';
import { Meteor } from 'meteor/meteor';
import styled from 'styled-components';
import { css } from '/imports/ui/css';
import { strings } from '/imports/strings';
import { defer } from '/imports/utils';
import { isAndroid } from '/imports/android';
import { isIos } from '/imports/ios';

const OAuth2ButtonStyled = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 3rem;
  background: ${css.primaryColor};
  border: 1px solid ${css.primaryColor};
  border-radius: ${css.inputBorderRadius};
  box-sizing: border-box;
  color: ${css.white} !important;
  font-weight: normal !important;
  text-decoration: none;
  &:hover {
    background: ${css.primaryColor2};
    border: 1px solid ${css.primaryColor2};
  }
  img {
    width: 1.5rem;
    margin-right: 0.5rem;
  }
`;

const GoogleButtonStyled = styled(OAuth2ButtonStyled)`
`;

/** Button linking to the Google OAuth2 consent flow. */
export const GoogleButton = () => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    defer(() => {
      const params = new URLSearchParams();
      params.set('response_type', 'code');
      params.set('client_id', Meteor.settings.public.google.oauth2.clientId);
      params.set('redirect_uri', Meteor.settings.public.google.oauth2.redirectUri);
      params.set('scope', 'openid email profile');
      params.set('flowName', 'GeneralOAuthFlow');
      params.set('state', state('google'));
      setUrl(`https://accounts.google.com/o/oauth2/auth/oauthchooseaccount?${params.toString()}`);
    });
  }, []);
  return (
    <GoogleButtonStyled href={url} target="_blank">
      <img src="/images/google_g_64.png" />{strings.UseGoogle()}
    </GoogleButtonStyled>
  );
};

const DiscordButtonStyled = styled(OAuth2ButtonStyled)`
`;

/** Button linking to the Discord OAuth2 consent flow. */
export const DiscordButton = () => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    defer(() => {
      const params = new URLSearchParams();
      params.set('response_type', 'code');
      params.set('client_id', Meteor.settings.public.discord.oauth2.clientId);
      params.set('redirect_uri', Meteor.settings.public.discord.oauth2.redirectUri);
      params.set('scope', 'openid email identify');
      params.set('state', state('discord'));
      setUrl(`https://discord.com/oauth2/authorize?${params.toString()}`);
    });
  }, []);
  return (
    <DiscordButtonStyled href={url} target="_blank">
      <img src="/images/discord_icon_64.png" />{strings.UseDiscord()}
    </DiscordButtonStyled>
  );
};

/**
 * Detects the current runtime platform.
 * @returns 'ios', 'android', or 'browser'
 */
const platform = () => {
  if (isIos()) return 'ios';
  if (isAndroid()) return 'android';
  return 'browser';
};

/**
 * Builds the base64-encoded OAuth2 state payload.
 * @param service - OAuth2 provider name
 * @returns base64 string carrying search params, platform, and service
 */
const state = (service: string) => {
  return window.btoa(JSON.stringify({ search: window.location.search || '', platform: platform(), service }));
};